<template>
<el-dialog title="批量搜索" :visible.sync="_visible" width="560px">

    <el-input type="textarea" :rows="15" placeholder="请输入账号ID。软文请使用网站标题名称，微博请用微博ID，微信请用微信ID，一行一个。" v-model="account_id">
    </el-input>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>


      <el-button type="primary" @click="submit">确 定</el-button>

    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["visible","taxonomy"],
  data() {
    return {
      account_id: "",
    };
  },
  computed:{
    _visible: {
        get() {
            return this.visible
        },
        set() {
            this.$emit('close')
        }
    },
  },
  watch: {
    visible(v) {
        this.visibleA = v
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
        const account_id = this.account_id.replace(/[\r\n]/g,"|");

        this.close();this.account_id = '';

        var field = this.taxonomy==='news'?'name':'account_id';

        this.$router.push(`/resource/${this.taxonomy}?_mode=es&${field}=${account_id}`)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/resource/BatchSearch.vue